import { render, staticRenderFns } from "./coveShedAddressList.vue?vue&type=template&id=08c2caae&scoped=true&"
import script from "./coveShedAddressList.vue?vue&type=script&lang=js&"
export * from "./coveShedAddressList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c2caae",
  null
  
)

export default component.exports